import { BookingStates } from '../../../../../constants/booking-states';

export const shouldShowManagePayments = (booking, isGuestView) => {
  const shouldShow =
    isGuestView &&
    booking.is_system_managed &&
    [
      BookingStates.ACTIVE,
      BookingStates.REQUESTED,
      BookingStates.GUEST_UPDATE_REQUESTED,
      BookingStates.HOST_UPDATE_REQUESTED,
      BookingStates.OFFER_SUBMITTED,
      BookingStates.EXPIRED,
      BookingStates.DECLINED,
      BookingStates.WITHDRAWN,
      BookingStates.CANCELLED,
      BookingStates.SETTLE_BALANCE_REQUIRED
    ].includes(booking.obj_state);

  return shouldShow;
};
